import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["on", "off"];

  enable() {
    this.#switch(true);
  }

  disable() {
    this.#switch(false);
  }

  #switch(on) {
    this.onTarget.disabled = !on;
    this.offTarget.disabled = on;
  }
}
